import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useRedirect = () => {
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if (location.pathname === '/') {
			navigate('/recommend', { replace: true });
		}
	}, [location.pathname, navigate]); // navigate 추가
};

export default useRedirect;
